export class Testimonial {
    id: number;
    title: string;
    rating;
    testimonial:string;
    name:string;
    role:string;
    company:string;
    published:number;
    constructor(testimonial?) {
        if (testimonial) {
            this.id = testimonial.id;
            this.title = testimonial.title;
            this.rating = testimonial.rating || 0;
            this.testimonial = testimonial.testimonial;
            this.name = testimonial.name;
            this.role = testimonial.role;
            this.company = testimonial.company;
            this.published=testimonial.published || 0;
        }
    }
}
